class WorkbenchStore {
  constructor(stage, deviceList) {
    this.databaseDevicesMap = {}; // 数据库中的所有点位信息，仅判断uuid是否存在
    this.workbenchDevicesMap = {}; // 工作区所有点位信息
    this.devicePhaseActions = {}; // 阶段性操作
    this.devicePoolActions = {}; // 提交池中的操作
    this.stage = stage;
    this.isLocked = false;
    this.synchronizeDatabaseInit(deviceList);
  }

  insertDevicePhaseActions(uuid, data) {
    this.devicePhaseActions[uuid] = data;
  }

  removeDevicePhaseActions(uuid) {
    delete this.devicePhaseActions[uuid];
  }

  insertWorkbenchDevices(uuid, data) {
    this.workbenchDevicesMap[uuid] = data;
  }

  removeWorkbenchDevices(uuid) {
    delete this.workbenchDevicesMap[uuid];
  }

  getCameraDataByUUID(uuid) {
    const camera = this.getCameraInstanceByUUID(uuid);
    if (!camera) {
      return null;
    }
    const { position } = camera;
    const { x, y, z } = position;
    const { _w: rw, _x: rx, _y: ry, _z: rz } = camera.getQuaternion(); // 暂时这么取四元数
    return { x, y, z, rw, rx, ry, rz };
  }

  getCameraInstanceByUUID(uuid) {
    const { stage } = this;
    if (!stage) {
      return null;
    }
    const elements = [...stage.elements];
    return elements.filter(e => e.universalId === uuid).pop();
  }

  addCamera() {}

  removeCamera() {}

  collectPositionORPoseActions(uuid) {
    const data = this.getCameraDataByUUID(uuid);
    if (!this.isDataChanged(uuid, data)) {
      return;
    }
    this.insertWorkbenchDevices(uuid, data);
    this.insertDevicePhaseActions(uuid, data);
  }

  isDataChanged(uuid, data) {
    if (!this.workbenchDevicesMap[uuid]) {
      // 不存在既新增
      return true;
    }
    return Object.entries(data).some(([key, value]) => {
      const oldData = this.workbenchDevicesMap[uuid];
      return oldData[key] !== value;
    });
  }

  clearDevicePhaseActions() {
    this.devicePhaseActions = {};
  }

  clearDevicePoolActions() {
    this.devicePoolActions = {};
  }

  pourPhaseActionsToPool() {
    // 加锁控制，仅异步修改databaseDevicesMap状态同步后才开锁
    if (this.isLocked) {
      return null;
    }
    this.isLocked = true;
    // 将一批阶段性操作注入到池中，等待批量处理，
    this.devicePoolActions = { ...this.devicePoolActions, ...this.devicePhaseActions };
    this.clearDevicePhaseActions();
    return this.devicePoolActions;
  }

  pourPoolActionsToDatabase() {
    // 成功存入数据库中，则将数据写入数据库中
    Object.keys(this.devicePoolActions).forEach(uuid => {
      this.databaseDevicesMap[uuid] = 1;
    });
    this.clearDevicePoolActions();
  }

  synchronizeDatabaseInit(devices = []) {
    devices.forEach(device => {
      const { uuid, x, y, z, rw, rx, ry, rz } = device;
      this.databaseDevicesMap[uuid] = 1;
      this.workbenchDevicesMap[uuid] = { x, y, z, rw, rx, ry, rz };
    });
  }
  // 成功失败都需要调用
  synchronizeDatabase(isSuccess) {
    if (isSuccess) {
      this.pourPoolActionsToDatabase();
    }
    // 必须等待toDatabase完成后（成功或失败），才能执行下一次 toPool
    this.isLocked = false;
  }

  isDeviceInDatabase(uuid) {
    return !!this.databaseDevicesMap[uuid];
  }

  isPhaseActionsEmpty() {
    return Object.keys(this.devicePhaseActions).length === 0;
  }

  isPoolActionsEmpty() {
    return Object.keys(this.devicePoolActions).length === 0;
  }

  getPhaseActions() {
    return this.pourPhaseActionsToPool();
  }
}

export default WorkbenchStore;
